import { LoaderFunctionArgs, redirect } from "react-router";
import * as Constants from 'common/helpers/constants';

export default async function rootLoader(args: LoaderFunctionArgs) {
  if (args.request.url === `${Constants.siteBaseUrl}/`) return redirect('/dashboard');
  return null;
}
